export default __webpack_public_path__ + "static/media/Ignite.41a47bcb.png";